<template>
  <v-app class="mx-auto">
    <v-app-bar
      style="border-top: 6px solid #e1d9cb; border-bottom: 6px solid #e1d9cb"
      color="coffee"
      order="2"
      height="84"
    >
      <v-row no-gutters class="align-center">
        <div class="v-col-2 d-lg-none d-flex justify-center">
          <v-btn id="menu-activator" icon="$menu" color="#015e72" aria-label="menu" />
        </div>
        <v-col cols="6" md="7" lg="3" xl="2" class="d-flex justify-center">
          <ImageLogo />
        </v-col>

        <v-col cols="7" md="7" lg="7" xl="9" class="d-none d-lg-block">
          <Menu
            :menu="page.menu"
            class="d-flex text-breadcrumbs font-weight-bold"
            :nav="true"
            bg-color="coffee"
            width="100%"
          />
        </v-col>

        <v-col :key="page.uri" cols="4" md="3" lg="2" xl="1" class="d-flex justify-center">
          <Button :download-nick="nick" :software-title="soft" :text="page.download?.title" />
        </v-col>
      </v-row>
    </v-app-bar>
    <v-menu activator="#menu-activator">
      <Menu :menu="page.menu" class="mt-4 text-breadcrumbs font-weight-bold" />
    </v-menu>
    <v-main class="mt-3 mx-auto container">
      <breadcrumbs
        v-if="page.breadcrumbs && page.breadcrumbs.length > 0"
        :items="page.breadcrumbs"
        devider-icon="$chevronRight"
        devider-color="breadcrumbs"
        class="py-0 ma-auto container"
      />
      <aside v-if="page.blocks?.AboveContent" class="my-1 mx-2">
        <Region :key="page.uri" region="AboveContent" :blocks="page.blocks.AboveContent" />
      </aside>

      <v-row v-if="page.blocks?.RightSide" no-gutters>
        <v-col cols="12" md="9">
          <article :key="page.uri" class="rounded mr-2 mt-2 pa-5 edge">
            <Article class="ma-2 pa-3"></Article>

            <Button
              :download-nick="nick"
              :software-title="soft"
              :text="page.download?.title"
              class="d-block ma-auto pa-2 mt-2 text-uppercase font-weight-bold"
            />
          </article>
          <aside v-if="page.blocks?.BelowContent" class="blockDesign mr-2 mt-2 pa-5">
            <Region :key="page.uri" region="BelowContent" :blocks="page.blocks.BelowContent" />
          </aside>
        </v-col>

        <aside v-if="page.blocks?.RightSide" class="v-col-12 v-col-md-3">
          <Region
            :key="page.uri"
            region="RightSide"
            :blocks="page.blocks.RightSide"
            class="blockDesign rightBlock mb-2"
            @noregion="page.hideRegion"
          />
        </aside>
      </v-row>
      <template v-else>
        <article :key="page.uri" class="rounded pa-5 ma-5 edge">
          <Article class="ma-2 pa-3"></Article>
          <Button
            :download-nick="nick"
            :software-title="soft"
            :text="page.download?.title"
            class="d-block ma-auto pa-2 mt-2 text-uppercase font-weight-bold"
          />
        </article>
        <aside v-if="page.blocks?.BelowContent" class="blockDesign ma-2 rounded">
          <Region :key="page.uri" region="BelowContent" :blocks="page.blocks.BelowContent" />
        </aside>
      </template>
      <footer v-if="page.blocks?.Footer" class="d-block">
        <Region :key="page.uri" region="Footer" :blocks="page.blocks.Footer" />
      </footer>
    </v-main>
  </v-app>
</template>
<script setup>
const page = inject("page");
const nick = ref(unref(page)?.rels?.downloadNick);
const soft = ref(unref(page)?.rels?.softwareTitle);

watchEffect(() => {
  nick.value = unref(page)?.rels?.downloadNick;
  soft.value = unref(page)?.rels?.softwareTitle;
});
</script>
